import UIkit from 'uikit'

let popinImageConfiguration = {
    /**
     * Component name
     * @type {String}
     */
    name: 'popin-image',

    /**
     * Component
     */
    $component: {},

    /** Data
     * @type {Object}
     */
    $data: {
        active: false,
        animated: false,
        carouselText: {},
        carouselVisuel: {}
    },

    /**
     * Create components
     * @void
     */
    init () {
        console.log('POPUP IMAGE Initialized')
        this.$component = document.querySelectorAll(`.${this.name}`)

        // function
        this.attachEventsHandlers()
        this.initLightbox()
        this.disableClick()
    },

    attachEventsHandlers () {
        window.addEventListener(
            'resize',
            () => {
                this.initLightbox()
                this.disableClick()
            }
        )
    },

    initLightbox () {
        let _options = {
            animation: 'fade',
            template: `<div class="uk-lightbox uk-overflow-hidden">
                            <ul class="uk-lightbox-items"></ul>
                            <div class="uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque">
                                <button class="uk-lightbox-toolbar-icon uk-close-large" type="button" uk-close></button>
                            </div>
                            <div class="uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque"></div>
                        </div>`
        }

        if (window.innerWidth >= 992) {
            UIkit.lightbox(
                this.$component,
                _options
            )
        }
    },

    disableClick () {
        this.$component.forEach(
            item => {
                let _link = item.querySelector('a')

                if (window.innerWidth < 992) {
                    _link.addEventListener(
                        'click',
                        event => {
                            event.preventDefault()
                        }
                    )
                }
            }
        )
    }
}

/**
 * Module export
 */
export default popinImageConfiguration
